import React from 'react';
import architectureImg from '../../assets/img/servicetrusted/1.png';

const ServiceTrusted = ({ 
  title = <><span className="text-primary">Trusted Outsourcing BIM Modeling</span> Company for US Construction Projects</>,
  paragraphs = [
    "We are a top BIM modeling service provider in the USA. With over 5 years of experience, we have successfully delivered more than 500 BIM projects nationwide.",
    "Our firm offers expert Outsourcing BIM services across sectors including Hospitality, Multi-Residential, Education, Commercial, Community, and Healthcare. We also serve Government, Retail, Manufacturing, and Warehouse/Storage clients.",
    "Our Revit BIM Modeling Services include Architectural Modeling, MEPF BIM Modeling, and Detailing. We also provide BIM Coordination & Clash Detection, As-built Models, Revit Family Creation, Point Cloud Scan-to-BIM, CAD-to-BIM conversions, and BIM for Facility Management."
  ],
  buttonText = "Get Your Free BIM Quote Today",
  imgSrc = architectureImg
}) => {
  return (
    <section className="service-trusted-new">
      <div className="trusted-new-container">
        <div className="trusted-new-left">
          <div className="trusted-image-wrapper">
            <img
              src={imgSrc.src || imgSrc}
              alt="US BIM Modeling"
              className="trusted-main-img"
            />
          </div>
        </div>

        <div className="trusted-new-right">
          <h2 className="trusted-new-title">
            {title}
          </h2>

          <div className="trusted-new-content">
            {paragraphs.map((p, index) => (
              <p key={index}>{p}</p>
            ))}
          </div>

          <button className="book-meeting-btn">
            {buttonText}
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServiceTrusted;
